<div class="psa-customization-form">
  <!-- Error message -->
  @if(metadataError) {
  <app-status-banner
    variant="detailed"
    type="warning"
    [body]="metadataError"
    title="PSA Data Error">
  </app-status-banner>
  }

  <!-- Loading message -->
  @if(showLoading && isLoadingMetadata) {
  <app-status-banner
    variant="standard"
    type="info"
    message="Loading PSA configuration options..."
  >
  </app-status-banner>
  }

  <!-- Formly Form with refresh button -->
  <div autocomplete="off" data-lpignore="true" data-form-type="other" class="psa-form-container">
    <formly-form
      [form]="form"
      [fields]="formFields"
      [model]="formModel"
    ></formly-form>

    <!-- Refresh Button - positioned next to board dropdown -->
    @if(showRefreshButton && connector) {
    <button
      type="button"
      class="btn btn-sm btn-icon psa-refresh-btn"
      (click)="reloadMetadata()"
      [disabled]="isLoadingMetadata"
      title="Refresh PSA data"
      aria-label="Refresh PSA data"
    >
      <i class="fa fa-refresh" [class.fa-spin]="isLoadingMetadata"></i>
    </button>
    }
  </div>
</div>
